import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dialog, IconButton, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Content, ContentText } from "./styles";
import DialogActions from "../../../../../../../../containers/DialogActions/DialogActions";
import DialogTitle from "../../../../../../../../containers/DialogTitle/DialogTitle";

interface Props {
  handleNotifyParent: () => void;
}

interface State {
  isDialogOpen: boolean;
}

const DeleteTravelExpense = ({ handleNotifyParent }: Props) => {
  const { t } = useTranslation();

  const theme = useTheme();

  const [state, setState] = useState<State>({
    isDialogOpen: false,
  });

  const handleClose = () => {
    setState((state) => ({
      ...state,
      isDialogOpen: false,
    }));
  };

  return (
    <>
      <IconButton
        className="delete_button"
        onClick={() => {
          setState((state) => ({
            ...state,
            isDialogOpen: true,
          }));
        }}
        sx={{
          display: "none",
          position: "absolute",
          top: 0,
          left: "50%",
          transform: "translate(-50%, -10%)",
          background: "white",
          borderRadius: "25px",
          width: "30px",
          height: "30px",
          boxShadow: theme.shadows[3],

          "&:hover": {
            background: "#E7E7E7",
          },
        }}
      >
        <FontAwesomeIcon
          icon={faTrash}
          color={theme.palette.error.main}
        />
      </IconButton>

      <Dialog
        open={state.isDialogOpen}
        onClose={handleClose}
      >
        <DialogTitle
          title={"Delete travel expense"}
          handleClose={handleClose}
        />
        <Content>
          <ContentText>{"Are you sure you want to delete this item?"}</ContentText>
        </Content>
        <DialogActions
          handleCancel={handleClose}
          useGoback
        >
          <Button
            onClick={handleNotifyParent}
            variant="contained"
            color="error"
          >
            {`${t("buttons.delete")}`}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteTravelExpense;
